import { PostHogProvider } from "posthog-js/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import posthog from "./analytics/posthogClient";
import "./styles/index.css";
import "./styles/tailwind.css";
import { installChunkReload } from "./utils/chunkReload";

// Antes do render: um deploy novo invalida os chunks da versão aberta, e o
// primeiro import que falhar já precisa recarregar em vez de quebrar a tela.
installChunkReload();

const container = document.getElementById("root");
const root = createRoot(container);

// O client já subiu (ou não, se estiver desabilitado) no import de
// posthogClient, que é quem decide o modo conforme o consentimento e reage às
// mudanças do banner. Aqui só o entregamos à árvore React — sem `apiKey`, para
// o provider não iniciar uma segunda instância com outra configuração.
root.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>,
);
